// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MeasuresCount[data-v-033b5db2]{display:flex;flex-direction:column;flex-wrap:wrap}.MeasuresCount>div[data-v-033b5db2]{margin:5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
